// liền - xám
const routeDrawStyle = {
  strokeColor: '#98A2B3',
  strokeOpacity: 0.7,
  strokeWeight: 7,
  zIndex: 90
}

// đứt - xanh duong
const routeEstimate = {
  strokeColor: '#4287f5', // Blue color
  strokeOpacity: 0, // Set opacity to 0 to hide the main line
  strokeWeight: 7,
  icons: [
    {
      icon: {
        path: 'M 0,-1 0,1', // Dash path
        strokeOpacity: 1,
        scale: 4
      },
      offset: '0',
      repeat: '16px' // Repeat dash every 10px
    }
  ],
  zIndex: 100
}

// liền - xanh duong
const routeActual = {
  strokeColor: '#4287f5',
  strokeOpacity: 0.7,
  strokeWeight: 7,
  zIndex: 95
}

// liền đỏ
const routeRed = {
  strokeColor: '#e60505',
  strokeOpacity: 0.7,
  strokeWeight: 7,
  zIndex: 90
}

export default {
  polylineStyle: {
    routeDrawStyle,
    routeEstimate,
    routeActual,
    routeRed
  }
}
